import { TipType } from '../../store/statistic';
import { StatisticValueType } from '../../store/subCategory';
import {
  DefaultFetchError,
  FetchCreate,
  useFetchCreate,
} from '../fetch';

export interface QuestionAnswer {
  type: StatisticValueType;
  valueBoolean: boolean;
  valueString: string;
  valueNumber: number;
  createdAt: string;
  updatedAt: string;
  id: string;
}

export interface QuestionCreateResponse {
  id: string;
}

export interface AnswerCreateData {
  valueBoolean?: boolean;
  valueString?: string;
  valueNumber?: number;
  valueArray?: (string | number)[];
  questionId: string;
  tipType: TipType;
}

export const useQuestionAnswerCreate = (): FetchCreate<
  QuestionCreateResponse,
  DefaultFetchError,
  AnswerCreateData
> => useFetchCreate(
  'questions/answers',
  { autoStart: false, startStateLoading: false },
);

export default {
  useQuestionAnswerCreate,
};
